import "../../PortfolioAddTransaction/styles/default.scss";

import classNames from "classnames";
import React from "react";

import withTranslations from "../../../../../hocs/withTranslations";
import FormBuilderWeb from "../../../../../lib/FormBuilder/FormBuilderWeb";
import FormsyComposedTextField from "../../../../../lib/FormBuilder/FormsyMaterialUI/FormsyComposedTextField";
import FormsyDatePicker from "../../../../../lib/FormBuilder/FormsyMaterialUI/FormsyDatePicker";
import { PRICE_FIELD_NAME } from "../../PortfolioAddTransaction/modules/default";
import SquaberAutocompleteWrapper from "../../SquaberAutocompleteWrapper";
import SquaberButton from "../../SquaberButton";

const ASSET_FIELD_NAME = "asset_name";

const PortfolioAddOtherAssetTransaction = ({
  withOtherAssetSelector = false,
  translate,
  formBuilder,
  autocompleteValue,
  setAutocompleteValue,
  calculateCommission,
  clearValidationError,
  validationErrors,
  setAutocompleteBlurred,
  loading,
  portfolioData
}) => {
  return (
    <tr
      className={classNames({
        "portfolio-add-transaction": true,
        "with-ticker-selector": withOtherAssetSelector
      })}
    >
      {withOtherAssetSelector ? (
        <td>
          <div className="form-builder">
            <SquaberAutocompleteWrapper
              htmlFor={ASSET_FIELD_NAME}
              name={ASSET_FIELD_NAME}
              label={"Name"}
              source={"app.portfolio.assetsFilteredByCurrency"}
              params={{
                limit: 99,
                offset: 0,
                currency: portfolioData.currency
              }}
              autocompleteValue={autocompleteValue.autocompleteValue}
              suggestionsCollectionResolver={(suggestions, inputValue) => {
                return (
                  suggestions?.result?.results
                    ?.filter?.(({ name }) => {
                      return name
                        .toLowerCase()
                        .startsWith(inputValue?.toLowerCase?.());
                    })
                    ?.map?.(({ name, id }) => {
                      return { price: "", label: name, value: id };
                    }) ?? []
                );
              }}
              setAutocompleteValue={value => {
                setAutocompleteValue(value);

                if (validationErrors?.[PRICE_FIELD_NAME]) {
                  clearValidationError(PRICE_FIELD_NAME);
                }
              }}
              setAutocompleteBlurred={setAutocompleteBlurred}
              maxLength={40}
              validations={{
                maxLength: 40
              }}
              validationErrors={{
                isDefaultRequiredValue: "This field is required",
                maxLength: "Other asset name can't be longer than 40 characters"
              }}
              required
            />
          </div>
        </td>
      ) : null}
      <td>
        <FormBuilderWeb
          {...formBuilder}
          fields={formBuilder.fields.filter(field => field.name === "type")}
          clearValidationError={clearValidationError}
          validationErrors={validationErrors}
          className="select-wrapper"
        />
      </td>
      <td>
        <div className="form-builder">
          <div>
            <FormsyDatePicker
              {...formBuilder.fields.filter(field => field.name === "date")[0]}
              onChange={value => {
                formBuilder.handleChange(
                  {
                    name: "date"
                  },
                  value
                );
                clearValidationError("date");
                clearValidationError(PRICE_FIELD_NAME);
              }}
            />
          </div>
        </div>
      </td>
      <td>
        <div className="form-builder">
          <div>
            <FormsyComposedTextField
              {...formBuilder.fields.filter(
                field => field.name === PRICE_FIELD_NAME
              )[0]}
              onChange={value => {
                formBuilder.handleChange(
                  {
                    name: PRICE_FIELD_NAME
                  },
                  value
                );
                clearValidationError(PRICE_FIELD_NAME);
              }}
              onBlur={() => {
                calculateCommission();
              }}
            />
          </div>
        </div>
      </td>
      <td>
        <div className="form-builder">
          <div>
            <FormsyComposedTextField
              {...formBuilder.fields.filter(
                field => field.name === "shares"
              )[0]}
              onChange={value => {
                formBuilder.handleChange(
                  {
                    name: "shares"
                  },
                  value
                );
                clearValidationError("shares");
              }}
              onBlur={() => {
                calculateCommission();
              }}
            />
          </div>
        </div>
      </td>
      <td>
        <FormBuilderWeb
          {...formBuilder}
          fields={formBuilder.fields.filter(
            field => field.name === "commission"
          )}
          clearValidationError={clearValidationError}
          validationErrors={validationErrors}
        />
      </td>
      <td>
        <SquaberButton
          type="submit"
          disabled={loading}
          onClick={() => {
            if (setAutocompleteBlurred) {
              setAutocompleteBlurred(true);
            }
          }}
        >
          {translate("Add")}
        </SquaberButton>
      </td>
    </tr>
  );
};

export default withTranslations(PortfolioAddOtherAssetTransaction);
